import { useSelector } from "react-redux";

import { getFormattedLocation } from "redux/selectors/location";

import ProductsAd from "../ProductsAd/ProductsAd";

const AD_UNITS = [
  "product_slot_1",
  "product_slot_2",
  "product_slot_3",
  "product_slot_4",
];

export const FeaturedProducts = ({
  categoryName,
  className,
  titleOverride,
}: {
  categoryName?: string;
  className?: string;
  titleOverride?: string;
}) => {
  const leaflyLocation = useSelector(getFormattedLocation);

  return (
    <section className={className}>
      <h2 className="mb-sm">
        {titleOverride ||
          `Featured ${categoryName || "Cannabis Products"} in
        ${leaflyLocation || "Seattle, WA"}`}
      </h2>
      <div className="row">
        {AD_UNITS.map((unit, i) => (
          <div
            className="mb-lg lg:mb-none col-1/2 lg:col-1/4"
            key={`featured-product-${i}`}
            data-testid={`featured-product-${i}`}
          >
            <div className="elevation-low rounded overflow-hidden min-h-[266px] flex items-center">
              <ProductsAd unit={unit} className="w-full" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
